<template>
  <div class="split_page">
    <div class="nav" @click="hideFn">返回模板列表页</div>
    <ul class="list_content clearfix">
      <li v-for="(item, key) in itemSet"
        :key="key"
        v-html="item"
        @click="electFn(item)">
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "comSplit_page",
  data() {
    return {};
  },
  methods: {
    electFn(data) {
      this.$emit("add_ueditor_value", data);
    },
    hideFn() {
      this.$emit("hide");
    }
  },
  props: {
    itemSet: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.split_page {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  color: #535353;
  position: absolute;
  top: 0;
  left: 0;

  .clearfix {
    zoom: 1;
    &::after {
      content: "";
      height: 0;
      line-height: 0;
      display: block;
      visibility: hidden;
      clear: both;
    }
  }

  .nav {
    line-height: 55px;
    padding-left: 20px;
    border-bottom: 1px solid #d9d9d9;
    cursor: pointer;
  }
  .list_content {
    width: 100%;
    padding: 15px 0 15px 12px;
    box-sizing: border-box;

    li {
      cursor: pointer;
      width: 360px;
      margin: 0 12px 10px 0;
      float: left;
      background-color: #fff;
      overflow: hidden;
      box-sizing: border-box;
      border: 1px solid #d9d9d9;

      &:hover {
        border: 1px solid $color;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/com-splitpage.vue